import {AppLang} from '@/i18n/localization/AppLangs'

export type ManualLandingData = (typeof manualLandingsFr)[number]

export const manualLandingObligationFibre = {
  url: 'obligation-adsl-fibre',
  seoTitle: 'Fibre optique : installation forcée par votre opérateur Internet ?',
  seoDesc: "Signalez un passage à la fibre forcé par votre fournisseur d'accès Internet",
  labelPlanDuSite: 'Faire un signalement pour une migration forcée vers la fibre optique',
} as const

export const manualLandingInfluenceur = {
  url: 'signaler-un-influenceur',
  seoTitle: "Signalez une publication frauduleuse d'un influenceur",
  seoDesc:
    "Vous avez repéré une publication trompeuse ou non conforme d'un influenceur sur Instagram, Snapchat, TikTok, etc. ? Signalez-la sur SignalConso.",
  labelPlanDuSite: 'Faire un signalement sur un influenceur',
} as const
export const manualLandingObsolescence = {
  url: 'duree-de-vie-produit-obsolescence-programmee',
  seoTitle: "Signaler un cas d'obsolescence programmée",
  seoDesc: 'Votre appareil a une durée de vie qui vous semble trop courte, indice de réparabilité manquant, ...',
  labelPlanDuSite: 'Faire un signalement pour un appareil dont la durée de vie vous semble trop courte',
} as const
export const manualLandingDemarchage = {
  url: 'demarchage-abusif',
  seoTitle: 'Démarchage téléphonique abusif',
  seoDesc: 'Signaler une entreprise qui vous appelle sans respecter Bloctel, ou hors des horaires autorisés',
  labelPlanDuSite: 'Faire un signalement pour un démarchage téléphonique abusif (malgré Bloctel, trop fréquent, etc.)',
} as const
export const manualLandingIntox = {
  url: 'intoxication-alimentaire',
  seoTitle: 'Intoxication alimentaire : vous avez mangé dans un restaurant et vous êtes malade ?',
  seoDesc: 'Signaler un établissement qui vous a rendu malade',
  labelPlanDuSite: 'Faire un signalement pour une intoxication alimentaire',
} as const
export const manualLandingFauxSiteGvt = {
  url: 'faux-site-gouvernemental',
  seoTitle: 'Faux site gouvernemental : signalez-le sur SignalConso',
  seoDesc: "Sites frauduleux imitant des services publics ou des sites de l'État, comment les repérer et s'en protéger",
  labelPlanDuSite: 'Faire un signalement pour un faux site gouvernemental',
} as const
export const manualLandingBfFausseReduc = {
  url: 'black-friday-fausse-reduction',
  seoTitle: 'Fausses réductions de prix pendant le Black Friday : signalez-le sur SignalConso',
  seoDesc:
    'Promotions mensongères, augmentation artificielle des prix juste avant la période pour afficher ensuite une fasse réduction...',
  labelPlanDuSite: 'Faire un signalement pour une fausse réduction de prix pendant le Black Friday',
} as const
export const manualLandingBlackFridayColis = {
  url: 'black-friday-retard-perte-colis',
  seoTitle: 'Retard de livraison, colis endommagé ou perdu : signalez-le sur SignalConso',
  seoDesc: "Votre livraison est retardée ou votre colis s'est perdu ? Renseignez-vous sur vos droits",
  labelPlanDuSite: 'Faire un signalement pour un colis endommagé ou non livré pendant le Black Friday',
} as const
export const manualLandingBlackFridaySav = {
  url: 'black-friday-sav',
  seoTitle: 'SAV inexistant ou injoignable : signalez-le sur SignalConso',
  seoDesc: "Le service après-vente (SAV) ne répond pas, n'existe pas, ou ses coordonnées sont introuvables ?",
  labelPlanDuSite: 'Faire un signalement pour un SAV non joignable pendant le Black Friday',
} as const
export const manualLandingVenteProduitsPlastiqueUsageUniqueInternet = {
  url: 'vente-de-produit-plastique-a-usage-unique-internet',
  seoTitle: 'Interdiction des plastiques à usage unique : Signalez les ventes illégales en ligne avec SignalConso',
  seoDesc:
    "Découvrez la réglementation sur les plastiques à usage unique interdits en France. Protégez vos droits et l'environnement en signalant les ventes illégales en ligne via SignalConso. Chaque action compte pour une consommation responsable !",
  labelPlanDuSite: 'Faire un signalement pour vente de produits en plastique à usage unique sur internet',
} as const
export const manualLandingVenteProduitsPlastiqueUsageUniqueMagasin = {
  url: 'vente-de-produit-plastique-a-usage-unique-magasin',
  seoTitle: 'Produits en plastique à usage unique : Signalez les ventes illégales en magasin avec SignalConso',
  seoDesc:
    "Découvrez la réglementation sur les plastiques à usage unique interdits en magasin. Agissez pour l'environnement en signalant les ventes illégales avec SignalConso. Ensemble, construisons un commerce responsable !",
  labelPlanDuSite: 'Faire un signalement pour vente de produits en plastique à usage unique en magasin',
} as const
export const manualLandingVenteEnLigneProduitsFaussesPromessesEcologiques = {
  url: 'tromperie-allegation-label-environnement-internet',
  seoTitle: 'Greenwashing en ligne : Signalez les fausses promesses écologiques avec SignalConso',
  seoDesc:
    'Découvrez comment repérer les fausses allégations environnementales sur les produits vendus en ligne. Luttez contre le greenwashing en signalant ces pratiques abusives via SignalConso pour un e-commerce plus responsable !',
  labelPlanDuSite: 'Faire un signalement pour vente en ligne de produits avec de fausses promesses écologiques',
} as const
export const manualLandingFaussesPromessesEcologiquesProduitsVendusEnMagasin = {
  url: 'tromperie-allegation-label-environnement-magasin',
  seoTitle: 'Lutte contre le greenwashing : Signalez les fausses promesses écologiques avec SignalConso',
  seoDesc:
    'Apprenez à repérer les fausses allégations environnementales en magasin et luttez contre le greenwashing. Signalez les pratiques trompeuses via SignalConso pour un commerce plus transparent et durable !',
  labelPlanDuSite: 'Faire un signalement pour fausses promesses écologiques sur des produits vendus en magasin physique',
} as const
export const manualLandingMarchesDeNoel = {
  url: 'marches-de-noel',
  seoTitle: 'Marchés de Noël : Achetez en toute confiance et signalez les abus avec SignalConso',
  seoDesc:
    "Profitez des marchés de Noël en toute sérénité ! Vérifiez l'origine des produits, les labels, et les prix pour des achats en confiance. En cas de problème, signalez-le sur SignalConso pour protéger vos droits.",
  labelPlanDuSite: 'Faire un signalement pour un abus sur un marché de Noël',
} as const

export function getManualLandings(lang: AppLang): readonly ManualLandingData[] {
  return lang === 'fr' ? manualLandingsFr : []
}

const manualLandingsFr = [
  manualLandingObligationFibre,
  {
    url: 'erreur-de-prix-en-caisse',
    seoTitle: 'Mauvais affichage des prix : Signalez-le sur SignalConso !',
    seoDesc:
      'Vous constatez un écart entre le prix affiché en magasin et celui en caisse ? Signalez-le sur SignalConso ! Protégez vos droits en cas de mauvais affichage des prix ou de promotions non appliquées. Agissez avec la DGCCRF pour corriger ces pratiques commerciales trompeuses.',
    labelPlanDuSite: 'Faire un signalement sur une erreur de prix en caisse',
  },
  {
    url: 'travaux-renovation',
    seoTitle: 'Travaux de rénovation : protégez vos droits et signalez les abus avec SignalConso',
    seoDesc:
      'Des problèmes avec vos travaux de rénovation ? Découvrez vos droits en tant que consommateur et faites un signalement sur SignalConso pour lutter contre les pratiques abusives : retards, malfaçons, non-respect des devis.',
    labelPlanDuSite: 'Faire un signalement pour des problèmes avec des travaux / rénovations',
  },
  {
    url: 'pompe-a-chaleur-pac',
    seoTitle: 'Pompe à chaleur : signalez les abus et défendez vos droits avec SignalConso',
    seoDesc:
      "Des problèmes d'installation ou d'entretien de votre pompe à chaleur ? Découvrez vos droits et signalez les pratiques abusives via SignalConso : installation défectueuse, devis trompeurs, performances non respectées.",
    labelPlanDuSite: "Faire un signalement concernant l'installation ou entretien d'une pompe à chaleur",
  },
  {
    url: 'repas-sur-place-couverts-jetables',
    seoTitle: 'Couverts jetables au restaurant : signalez-le sur SignalConso',
    seoDesc:
      "Découvrez l'impact environnemental des couverts jetables et la législation en vigueur. Agissez pour une restauration durable en signalant les infractions sur SignalConso.",
    labelPlanDuSite: 'Faire un signalement sur un repas sur place avec couverts jetables',
  },
  {
    url: 'fourniture-systematique-echantillons-internet',
    seoTitle: 'Échantillons gratuits non sollicités : signalez-les sur SignalConso',
    seoDesc:
      "Découvrez l'impact écologique des échantillons non sollicités. Agissez pour une consommation durable en signalant ces pratiques sur SignalConso.",
    labelPlanDuSite: "Faire un signalement pour fournitures systematiques d'échantillons",
  },
  {
    url: 'distribution-gratuite-bouteilles-plastique',
    seoTitle: 'Distribution gratuite de bouteilles plastiques : Signalez sur SignalConso',
    seoDesc:
      "Découvrez l'impact écologique des bouteilles plastiques gratuites. Agissez pour l'environnement en signalant ces distributions sur SignalConso.",
    labelPlanDuSite: 'Faire un signalement pour distribution gratuite de bouteilles en plastique',
  },
  {
    url: 'informations-environnementales-vehicules-neufs',
    seoTitle: 'Infos environnementales véhicules neufs : Signalez sur SignalConso',
    seoDesc:
      "Découvrez vos droits sur les informations environnementales des véhicules neufs. Signalez l'absence d'étiquette énergie sur SignalConso pour protéger l'environnement.",
    labelPlanDuSite: 'Faire un signalement sur informations environnementales de vehicules neufs',
  },
  {
    url: 'allegation-neutralite-compensation-carbone',
    seoTitle: 'Neutralité Carbone : Comment repérer les allégations douteuses et signaler sur SignalConso',
    seoDesc:
      'Découvrez comment repérer les fausses allégations de neutralité carbone et protégez vos droits en tant que consommateur. Signalez les pratiques trompeuses sur SignalConso et luttez contre le greenwashing.',
    labelPlanDuSite: 'Faire un signalement sur des allegations de neutralite compensation carbone',
  },
  {
    url: 'impression-systematique-ticket-de-caisse',
    seoTitle: 'Ticket de caisse imprimé sans demande : comment signaler avec SignalConso',
    seoDesc:
      'Depuis août 2023, les tickets de caisse ne doivent plus être imprimés automatiquement. Découvrez vos droits et comment signaler les infractions via SignalConso pour réduire le gaspillage.',
    labelPlanDuSite: 'Faire un signalement sur des impressions systematiques de tickets de caisse',
  },
  manualLandingInfluenceur,
  manualLandingObsolescence,
  manualLandingDemarchage,
  manualLandingIntox,
  manualLandingFauxSiteGvt,
  {
    url: 'black-friday-abonnement-frais-caches',
    seoTitle: 'Abonnements ou frais cachés : signalez-le sur SignalConso',
    seoDesc:
      'Vous avez été piégé par un abonnement caché, ou des frais non annoncés, et découvrez des prélèvements inexpliqués... signalez une pratique commerciale trompeuse.',
    labelPlanDuSite: 'Faire un signalement pour des abonnements ou frais cachés pendant le Black Friday',
  },
  manualLandingBlackFridayColis,
  {
    url: 'black-friday-dark-patterns',
    seoTitle: 'Dark patterns sur un site web : signalez-le sur SignalConso',
    seoDesc: `Vous avez repéré un site avec une interface trompeuse, utilisant des "dark patterns" manipulant le consommateur pour le pousser à l'achat ou à l'abonnement`,
    labelPlanDuSite: 'Faire un signalement pour une interface trompeuse (dark pattern) pendant le Black Friday',
  },
  manualLandingBfFausseReduc,
  {
    url: 'black-friday-faux-stocks',
    seoTitle: 'État des stocks pendant le Black Friday : signalez-le des pratiques trompeuses sur SignalConso',
    seoDesc: 'Sites affichant "stock limité" ou "dernière chance", alors que les produits sont largements en stocks',
    labelPlanDuSite: "Faire un signalement pour des fausses infos sur les stocks d'un produit pendant le Black Friday",
  },
  manualLandingBlackFridaySav,
  {
    url: 'black-friday-sites-frauduleux',
    seoTitle: 'Sites frauduleux pendant le Black Friday : signalez-le sur SignalConso',
    seoDesc:
      'Imitation de sites officiels ou de boutiques de confiance, pour arnaquer les internautes ou leur voler des informations personnelles, ventes de contrefaçons, ...',
    labelPlanDuSite: 'Faire un signalement pour un site frauduleux pendant le Black Friday',
  },
  {
    url: 'black-friday-garanties',
    seoTitle: 'Garanties légales pendant le Black Friday : renseignez-vous sur SignalConso',
    seoDesc:
      'Garantie légale de conformité, garantie contre les vices cachés : que faire si le produit tombe en panne ou présente un défaut ?',
    labelPlanDuSite: 'Faire un signalement pour mauvaise application des garanties pendant le Black Friday',
  },
  {
    url: 'black-friday-droit-retractation',
    seoTitle: 'Droit de rétractation pendant le Black Friday : renseignez-vous sur SignalConso',
    seoDesc:
      'Le droit de rétractation est une protection légale qui vous permet de renvoyer un produit acheté à distance, pendant un certain délai',
    labelPlanDuSite: 'Faire un signalement pour non respect du droit de rétractation pendant le Black Friday',
  },
  {
    url: 'hygiene-douteuse-personnel-restauration',
    seoTitle: "Signalez les problèmes d'hygiène dans les restaurants avec SignalConso",
    seoDesc:
      'Constaté un problème d’hygiène dans un restaurant, café ou bar ? Protégez vos droits et ceux des autres consommateurs : signalez les mauvaises pratiques sur SignalConso et contribuez à un environnement plus sûr.',
    labelPlanDuSite: "Faire un signalement concernant un problème d'hygiène dans un restaurant, un café ou un bar",
  },
  {
    url: 'demarches-administratives',
    seoTitle: 'Attention aux arnaques administratives : protégez-vous avec SignalConso',
    seoDesc:
      'Ne vous laissez pas tromper par les faux sites se faisant passer pour des administrations ! Découvrez vos droits, les risques des pratiques frauduleuses, et comment signaler ces arnaques sur SignalConso pour protéger vos données et votre argent',
    labelPlanDuSite: "Faire un signalement concernant un site se faisant passer pour l'administration",
  },
  {
    url: 'achat-site',
    seoTitle: 'Achat en ligne : protégez vos droits et signalez les abus avec SignalConso',
    seoDesc:
      'Un problème lors de votre achat en ligne ? Produit non conforme, retard de livraison ou arnaque ? Découvrez vos droits et signalez les pratiques abusives sur SignalConso pour protéger les consommateurs et obtenir justice.',
    labelPlanDuSite: 'Faire un signalement pour un achat sur internet',
  },
  {
    url: 'dysfonctionnements-commandes-nourriture',
    seoTitle: 'Problème de commande en ligne de nourriture - Vos droits et solutions',
    seoDesc:
      'Découvrez vos droits en cas de problèmes avec vos commandes de nourriture en ligne. Livraison en retard, commande incomplète ou mauvaise qualité ? Signalez un dysfonctionnement avec Signal Conso.',
    labelPlanDuSite: 'Faire un signalement concernant une commande de nourriture en ligne',
  },
  manualLandingVenteProduitsPlastiqueUsageUniqueInternet,
  manualLandingVenteProduitsPlastiqueUsageUniqueMagasin,
  manualLandingVenteEnLigneProduitsFaussesPromessesEcologiques,
  manualLandingFaussesPromessesEcologiquesProduitsVendusEnMagasin,
  manualLandingMarchesDeNoel,
  {
    url: 'arnaques-primes-energie-renovation',
    seoTitle: "Arnaques et problèmes liés aux primes d'énergie et aux aides à la rénovation",
    seoDesc:
      "Signalez un problème d'arnaque, de non-attribution ou de détournement lié aux primes, d'énergie ou aux aides à la rénovation.",
    labelPlanDuSite: "Faire un signalement concernant un problème liés aux primes d'énergie et aux aides à la rénovation",
  },
] as const
